// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  userIdentity: __t.identity().name("user_identity"),
  version: __t.string(),
  platform: __t.string(),
  appsFolder: __t.string().name("apps_folder"),
  lastHeartbeat: __t.timestamp().name("last_heartbeat"),
  online: __t.bool(),
  statusMessage: __t.option(__t.string()).name("status_message"),
});
